import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasConocimientosTecnicosAtom, puntajeTotalConocimientosTecnicosAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasConocimientosTecnicos = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalConocimientosTecnicosAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasConocimientosTecnicosAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasConocimientosTecnicos;
